// Central contact / booking configuration
export const BOOKING_URL = "https://booktaxinow.co.uk/";

// WhatsApp: UK number 07365874733 -> international 44 7365874733
export const WHATSAPP_NUMBER = "447365874733";
export const WHATSAPP_DISPLAY = "+44 7365 874733";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;

// Call: 02038393300
export const PHONE_NUMBER = "02038393300";
export const PHONE_DISPLAY = "020 3839 3300";
export const PHONE_TEL = "tel:+442038393300";

// Address
export const ADDRESS = "London";
export const ADDRESS_LINE1 = "London";
export const ADDRESS_LINE2 = "";

// Email
export const EMAIL = "info@taxi24hrs.co.uk";
export const EMAIL_MAILTO = "mailto:info@taxi24hrs.co.uk";
